import { sygnet } from './sygnet'
import { logo } from './logo'
import { smallLogo } from './small-logo'
import { logoNegative } from './logo-negative'
import { meditation } from './meditation'
import { awful } from './moods/awful'
import { bad } from './moods/bad'
import { good } from './moods/good'
import { great } from './moods/great'
import { ok } from './moods/ok'
import { bushi, chijie, chanxiu, fuwu, gongjing, huixiang, suixi, tingwen, hongyang, zhengjian } from './wealth'

import {
  cibAppleMusic,
  cibSkype,
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex
} from '@coreui/icons'
import {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl
} from '@coreui/icons'
import {
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilAperture,
  cilApplicationsSettings,
  cilArrowRight,
  cilArrowCircleLeft,
  cilArrowCircleRight,
  cilArrowTop,
  cilAsterisk,
  cilBan,
  cilBasket,
  cilBell,
  cilBold,
  cilBook,
  cilBookmark,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChartPie,
  cilCheck,
  cilCheckAlt,
  cilChevronBottom,
  cilChevronLeft,
  cilChevronRight,
  cilChevronTop,
  cilCircle,
  cilCheckCircle,
  cilCode,
  cilCommentSquare,
  cilCreditCard,
  cilCursor,
  cilCursorMove,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeLetter,
  cilEnvelopeOpen,
  cilEuro,
  cilExternalLink,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilFolderOpen,
  cilFullscreen,
  cilFullscreenExit,
  cilGraph,
  cilHappy,
  cilHome,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilInputPower,
  cilItalic,
  cilJustifyCenter,
  cilJustifyLeft,
  cilLaptop,
  cilLayers,
  cilList,
  cilListNumbered,
  cilListRich,
  cilLocationPin,
  cilMagnifyingGlass,
  cilMap,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPencil,
  cilPhone,
  cilPlus,
  cilPrint,
  cilPuzzle,
  cilSave,
  cilScreenDesktop,
  cilSchool,
  cilScrubber,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilTags,
  cilTask,
  cilTrash,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  cilVolumeHigh,
  cilX,
  cilXCircle,
  cilWarning,

  cilFire,
  cilHeart,
  cilFace,
  cilFaceDead,
  cilAssistiveListeningSystem,
  cilLightbulb,
  cilEducation,
  cilGroup,
  cilBaby,
  cilSmile,
  cilSmilePlus,
  cilKeyboard,
  cilZoom,
  cilLockLocked,
  cilLockUnlocked,
  cilBullhorn,
  cilMoodGood,
  cilPlant,
  cilPeople,
  cilSignLanguage,
  cilBadge,
  cilApps,
  cilAddressBook,
  cilDescription,
  cilColorBorder,
} from '@coreui/icons'

export const icons = Object.assign({}, {
  sygnet,
  logo,
  smallLogo,
  logoNegative,
  meditation,
  bushi,
  chijie,
  chanxiu,
  fuwu,
  gongjing,
  huixiang,
  suixi,
  tingwen,
  hongyang,
  zhengjian,
  awful,
  bad,
  good,
  great,
  ok,
}, {
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilAperture,
  cilApplicationsSettings,
  cilArrowCircleLeft,
  cilArrowCircleRight,
  cilArrowRight,
  cilArrowTop,
  cilAsterisk,
  cilBan,
  cilBasket,
  cilBell,
  cilBold,
  cilBook,
  cilBookmark,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChartPie,
  cilCheck,
  cilCheckAlt,
  cilChevronBottom,
  cilChevronLeft,
  cilChevronRight,
  cilChevronTop,
  cilCircle,
  cilCheckCircle,
  cilCode,
  cilCommentSquare,
  cilCreditCard,
  cilCursor,
  cilCursorMove,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeLetter,
  cilEnvelopeOpen,
  cilEuro,
  cilExternalLink,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilFolderOpen,
  cilFullscreen,
  cilFullscreenExit,
  cilGraph,
  cilHappy,
  cilHome,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilInputPower,
  cilItalic,
  cilJustifyCenter,
  cilJustifyLeft,
  cilLaptop,
  cilLayers,
  cilList,
  cilListNumbered,
  cilListRich,
  cilLocationPin,
  cilMagnifyingGlass,
  cilMap,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPencil,
  cilPhone,
  cilPlus,
  cilPrint,
  cilPuzzle,
  cilSave,
  cilScreenDesktop,
  cilSchool,
  cilScrubber,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilTags,
  cilTask,
  cilTrash,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  cilVolumeHigh,
  cilX,
  cilXCircle,
  cilWarning,

  cilFire,
  cilHeart,
  cilFace,
  cilFaceDead,
  cilAssistiveListeningSystem,
  cilLightbulb,
  cilEducation,
  cilGroup,
  cilBaby,
  cilSmile,
  cilSmilePlus,
  cilKeyboard,
  cilZoom,
  cilLockLocked,
  cilLockUnlocked,
  cilBullhorn,
  cilMoodGood,
  cilPlant,
  cilPeople,
  cilSignLanguage,
  cilBadge,
  cilApps,
  cilAddressBook,
  cilDescription,
  cilColorBorder,
}, {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl
}, {
  cibAppleMusic,
  cibSkype,
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex
})
